import {useRouter} from 'next/router';
import {env} from 'next-runtime-env';

export const useDebugView = () => {
  const router = useRouter();
  const isDebugView = router && router.query.isDebugView === 'true';
  return isDebugView;
};

export const useDebugValues = () => {
  const router = useRouter();
  const hasExtraPrivateRoomTime = router && router.query.hasExtraPrivateRoomTime === 'true';
  return {hasExtraPrivateRoomTime};
};

export const useRuntimeEnv = () => {
  const NEXT_PUBLIC_RUNTIME_ENV = env('NEXT_PUBLIC_RUNTIME_ENV');
  const isLocal = NEXT_PUBLIC_RUNTIME_ENV === 'development';

  return {runtimeEnv: NEXT_PUBLIC_RUNTIME_ENV, isLocal};
};
